import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/theme.css';
import './styles/tokens.css';
import './styles/componentes.css';
import './styles/index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const raiz = document.getElementById('root');
/* Prévia pré-renderizada de outra rota (ver public/index.html): sai antes de o
   React desenhar. */
if (document.documentElement.classList.contains('sem-previa')) {
  raiz.textContent = '';
  document.documentElement.classList.remove('sem-previa');
}

const root = ReactDOM.createRoot(raiz);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
